// extracted by mini-css-extract-plugin
module.exports = {"container":"WorldWideList__container","selects":"WorldWideList__selects"};